import { useIsAuthenticated } from '@azure/msal-react';
import { environment } from '@environments/environment';

export function useIsMsalAuthenticated(): boolean {
  const isAuthenticated = useIsAuthenticated();
  return environment.useAuth ? isAuthenticated : true;
}
